const routes = [
  {
    // 多笔立减活动 
    path: '/mutipleDiscount',
    name: 'mutipleDiscount',
    component: () => import('@/views/mutipleDiscount/index.vue'),
    meta: {
      requiresAuth: false,
      title: '多笔随机立减活动 '
    }
  },
]

export default routes
